export const CONVENIENCE_DECREASE = 'CONVENIENCE_DECREASE'
export const CONVENIENCE_INCREASE = 'CONVENIENCE_INCREASE'
export const CONVENIENCE_SET_TOTAL = 'CONVENIENCE_SET_TOTAL'
export const CONVENIENCE_FETCH_TOTAL = 'CONVENIENCE_FETCH_TOTAL'